import logo from './logo.svg';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer'
import HomePage from './Components/HomePage';
import About from './Components/About/About';
import Destination from './Components/Destination/Destination';
import FAQs from './Components/FAQ\'s/faq';
import ContactUs from './Components/Contact_Us/ContactUs';
import Blogs from './Components/Blogs/Blogs';
import Blogs_Data from './Components/Blogs/Blogs_Data';
import Travel_Reg_Form from './Components/Application_Form/Application_Form';
import Travel_Reg_Form1 from './Components/Application_Form/Application_Form_1';
import { useEffect,useState} from 'react';
import 'aos/dist/aos.css';  
import AOS from 'aos';
import ApplicationLookup from './Components/Application_Form/ApplicationLookup';
import Canada from '../src/Components/Countries/Canada';
import Australia from './Components/Countries/Australia';
import USA from './Components/Countries/USA';
import U from './Components/Countries/Uk';
import Schengen_Visa from './Components/Countries/Schengen';
import Turkey_Visa from './Components/Countries/Turkey';
import UK from './Components/Countries/Uk';
import Student_Form from './Components/Student_Form/Student_Form';
import AdminDashboard from './Components/Admin/AdminDashboard';
import AdminProtectedRoute from './Components/Admin/AdminProtectedRoute';
import AdminLogin from './Components/Admin/AdminLogin';
import UserLogin  from './Components/User/UserLogin';
import UserDashboard  from './Components/User/UserDashboard';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';



function App() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      easing: 'ease-in-out', 
      once: true,
      delay: 200, 
    });
  }, []);

 // Check for existing user session on app load
  useEffect(() => {
    const checkUserSession = () => {
      const userToken = localStorage.getItem('userToken');
      const userData = localStorage.getItem('userData');
      
      if (userToken && userData) {
        try {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
          setIsAdmin(parsedUser.role === 'admin');
        } catch (error) {
          console.error('Error parsing user data:', error);
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
        }
      }
      setIsLoading(false);
    };
    
    checkUserSession();
  }, []);

  const handleLoginSuccess = (userData) => {
    console.log("userData",userData);
    setUser(userData);
    setIsAdmin(userData.role === 'admin');
  };

  const handleLogout = () => {
    setUser(null);
    setIsAdmin(false);
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
  };

  if (isLoading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
 <div className="page-wrapper" style={{backgroundColor:'#232c27'}}>

<Router>
       <Header/> 
  <Routes>     
          <Route path="/" element={<HomePage />} />
          <Route path="/AboutUs" element={<About />} />  
            <Route path="/Destination" element={<Destination/>} />
            <Route path="/FAQs" element={<FAQs/>} />
            <Route path="/Contact" element={<ContactUs/>} />
            <Route path='/Blogs' element={<Blogs/>}/>
            <Route path='/Blogs_Details' element={<Blogs_Data/>}/>
            <Route path="/Application_Form" element={<Travel_Reg_Form1/>}/>
            <Route path="/tracking" element={<ApplicationLookup/>}/>
            <Route path='/Student_Form'  element={<Student_Form/>}/>


            <Route path="/Canada_visa" element={<Canada/>} />
          <Route path="/Uk_visa" element={<UK/>} />
          <Route path="/Australia_visa" element={<Australia/>} />
          <Route path="/USA_visa" element={<USA/>} />
          <Route path="/Turkey_visa" element={<Turkey_Visa/>} />
          <Route path="/Shengen_visa" element={<Schengen_Visa/>} />
          

<Route path="/admin" element={<AdminDashboard />} />
<Route path="/admin" element={<AdminProtectedRoute />} />
<Route path="/admin-login" element={<AdminLogin />} />

 <Route path="/user/login" element={<UserLogin onLoginSuccess={handleLoginSuccess} />} />
          <Route 
            path="/user/dashboard" 
            element={user && !isAdmin ? <UserDashboard userData={user} onLogout={handleLogout} /> : <Navigate to="/user/login" />} 
          />
        </Routes>

      <Footer/>
  
      </Router>
 </div>


 
  );
}

export default App;
